import React from 'react'
import Hero from '../components/landing/Hero'
import BetaPricing from '../components/landing/BetaPricing'
import { LEMONSQUEEZY_CHECKOUT_URL } from '../config/checkout'

export default function BetaPricingPage() {
  const handleStartCheckout = () => {
    // Option A: Direct redirect to LemonSqueezy
    window.location.href = LEMONSQUEEZY_CHECKOUT_URL
    
    // Option B: If using Wasp action, replace above with:
    // const startCheckout = useAction(startCheckoutAction)
    // startCheckout({ plan: 'founder_monthly_20' })
  }

  const handleHowItWorks = () => {
    // TODO: Open "How it works" modal or navigate to demo page
    console.log('Show how it works')
  }

  return (
    <div className="min-h-screen bg-neutral-950">
      <Hero 
        onPrimaryClick={handleStartCheckout}
        onSecondaryClick={handleHowItWorks}
      />
      <BetaPricing 
        onSubscribe={handleStartCheckout}
      />
    </div>
  )
}